import React, { Dispatch } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose, bindActionCreators } from 'redux';
import { translate } from 'react-i18next';

import { edit, filterChange, filterClear } from '../../actions/tableActions';
import Table from '../common/Table';
import { GridColumn as Column } from '@progress/kendo-react-grid';
import StringCell from '../common/formatters/StringCell';
import EnumCell from '../common/formatters/EnumCelll';
import DateTimeCell from '../common/formatters/DateTimeCell';
import NavigableCell from '../common/formatters/navigableCell';
import Translation from '../common/Translation';
import Alerts from '../common/Alerts';
import { OUTAGE_NOTIFICATION } from '../../data-transformations/dataTransformationTypes';
import { navigateTo } from '../../actions/navigationActions';
import * as enums from '../../common/enums';
import { TEXT_HORIZONTAL_ALIGN, NAVIGATION_PATHS } from '../../common/constants';
import OutageNotificationActionsBar from './outageNotificationActionsBar';
import { BaseListProps } from '../common/types/baseDetail';

const defaultRatingTabelSort = [
    {
        dir: 'desc',
        field: 'dateOfCreate',
    },
];

const actionUrl = 'outageNotification';

interface OutageNotificationProps extends OutageNotificationDispatchProps, BaseListProps {}
interface OutageNotificationDispatchProps {
    navigateTo: typeof navigateTo;
    onEdit: () => void;
    filter: ([]) => void;
    clearFilter: () => void;
}

const OutageNotification = ({ t, navigateTo, filter, clearFilter }: OutageNotificationProps) => {
    let table: any;

    const customRowRender = (trElement: any) => {
        console.warn('OutageNotification.rowRender');

        return trElement;
    };

    const onNew = () => {
        navigateTo(NAVIGATION_PATHS.OUTAGE_NOTIFICATION_CREATE);
    };

    const onRemove = () => {
        table.getWrappedInstance().removeSelected();
    };

    return (
        <div>
            <div className="content-header">
                <h1>
                    <Translation tKey="OutageNotifications" />
                </h1>
            </div>
            <div className="content-wrapper">
                <Alerts />
                <div className="panel">
                    <div className="panel-header">
                        <OutageNotificationActionsBar
                            onEdit={edit}
                            filter={filter}
                            clearFilter={clearFilter}
                            onNew={onNew}
                            onRemove={onRemove}
                        />
                        <div className="filter" />
                    </div>
                    <div className="panel-content">
                        <Table
                            path={'outageNotification'}
                            actionPath={actionUrl}
                            selectedField="selected"
                            ref={(el) => {
                                table = el;
                            }}
                            dataTransformation={OUTAGE_NOTIFICATION}
                            name="OutageNotificationTable"
                            customRowRender={customRowRender}
                            defaultSort={defaultRatingTabelSort}
                        >
                            <Column field="selected" width="50" />
                            <Column
                                field="order"
                                cell={(props) => (
                                    <NavigableCell
                                        {...props}
                                        actionUrl={actionUrl}
                                        navigateTo={navigateTo}
                                        component={StringCell(TEXT_HORIZONTAL_ALIGN.LEFT)}
                                    />
                                )}
                                title={t('Order')}
                                width="75px"
                            />
                            <Column
                                field="name"
                                width="250"
                                cell={(props) => (
                                    <NavigableCell
                                        {...props}
                                        actionUrl={actionUrl}
                                        navigateTo={navigateTo}
                                        component={StringCell(TEXT_HORIZONTAL_ALIGN.LEFT)}
                                    />
                                )}
                                title={t('Name')}
                            />
                            <Column
                                field="platformEnumDescription"
                                width="150"
                                cell={(props) => (
                                    <NavigableCell
                                        {...props}
                                        actionUrl={actionUrl}
                                        navigateTo={navigateTo}
                                        component={EnumCell(enums.PLATFORMA_TYPES)}
                                    />
                                )}
                                title={t('Platform')}
                            />
                            <Column
                                field="notificationFrom"
                                width="150"
                                cell={(props) => <NavigableCell {...props} actionUrl={actionUrl} navigateTo={navigateTo} component={DateTimeCell} />}
                                title={t('NotificationFrom')}
                            />
                            <Column
                                field="outageFrom"
                                width="150"
                                cell={(props) => <NavigableCell {...props} actionUrl={actionUrl} navigateTo={navigateTo} component={DateTimeCell} />}
                                title={t('OutageFrom')}
                            />
                            <Column
                                field="outageTo"
                                width="150"
                                cell={(props) => <NavigableCell {...props} actionUrl={actionUrl} navigateTo={navigateTo} component={DateTimeCell} />}
                                title={t('OutageTo')}
                            />
                            <Column
                                field="notificationTo"
                                width="150"
                                cell={(props) => <NavigableCell {...props} actionUrl={actionUrl} navigateTo={navigateTo} component={DateTimeCell} />}
                                title={t('NotificationTo')}
                            />
                            <Column
                                field="text"
                                cell={(props) => (
                                    <NavigableCell
                                        {...props}
                                        actionUrl={actionUrl}
                                        navigateTo={navigateTo}
                                        component={StringCell(TEXT_HORIZONTAL_ALIGN.LEFT)}
                                    />
                                )}
                                title={t('Text')}
                            />
                        </Table>
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapDispatchToProps = (dispatch: Dispatch<any>): OutageNotificationDispatchProps => {
    return {
        navigateTo: bindActionCreators(navigateTo, dispatch),
        clearFilter: bindActionCreators(filterClear, dispatch),
        filter: bindActionCreators(filterChange, dispatch),
        onEdit: bindActionCreators(edit, dispatch),
    };
};

export default compose(connect(null, mapDispatchToProps), translate('common'))(OutageNotification);
